import { Col, Icon, Layout, Row } from 'antd';
import React from 'react';
import ProfileMenu from '../../containers/ProfileMenu/ProfileMenu';

const { Header } = Layout;

export const DashboardLayout = (WrappedComponent) => {

  return class extends React.Component {

    render() {

      return (
        <Layout>
          <Header
            style={{
              background: '#ffffff',
              padding: 0,
              height: '50px',
              lineHeight: '50px',
            }}
          >
            <Row>
              <Col xs={18} sm={20} style={{paddingLeft: '5px'}}>
                <span className={'logo'}/>
                <span style={{color: '#000'}}>
                <Icon
                  style={{
                    fontSize: '18px',
                    verticalAlign: 'middle',
                    margin: '0 5px 0 5px',
                  }}
                  type="compass"
                  theme="twoTone"
                />
                <span
                  style={{
                    fontSize: '18px',
                    verticalAlign: 'middle',
                    fontFamily: 'sans-serif',
                  }}
                >
                Logistics
                </span>
                </span>
              </Col>
              <Col xs={6} sm={4} style={{paddingLeft: '5px'}}>
                <ProfileMenu/>
              </Col>
            </Row>
          </Header>
          <Layout>
            <WrappedComponent {...this.props}/>
          </Layout>
        </Layout>
      );
    }
  };
};
